import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const LeaveTypesContext = createContext({ types: [], map: {}, reload: () => {} });

export function LeaveTypesProvider({ children }) {
  const [types, setTypes] = useState([]);
  const reload = useCallback(() => {
    api.get("/leave-types").then((r) => setTypes(r.data)).catch(() => {});
  }, []);
  useEffect(() => { reload(); }, [reload]);
  const map = Object.fromEntries(types.map((t) => [t.key, t]));
  return (
    <LeaveTypesContext.Provider value={{ types, map, reload }}>
      {children}
    </LeaveTypesContext.Provider>
  );
}

export const useLeaveTypes = () => useContext(LeaveTypesContext);
